export function isFunction ( value: unknown ) {
  return typeof value === "function";
}

export function isObject ( obj: unknown ) {
  return obj !== null && typeof obj === "object";
}

export function isString ( value: unknown ) {
  return typeof value === "string";
}

export function isNumber ( value: unknown ) {
  return typeof value === "number";
}

export function isArray ( value: unknown ) {
  return Array.isArray( value );
}

export function isEmpty ( value: unknown ) {
  return value === null || value === undefined || value === "" || ( Array.isArray( value ) && value.length === 0 ) || ( !( value instanceof Date ) && typeof value === "object" && Object.keys( value ).length === 0 );
}
